import { render, staticRenderFns } from "./TabHistorico.vue?vue&type=template&id=12b75afe&scoped=true&"
import script from "./TabHistorico.vue?vue&type=script&lang=js&"
export * from "./TabHistorico.vue?vue&type=script&lang=js&"
import style0 from "./TabHistorico.vue?vue&type=style&index=0&id=12b75afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b75afe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VIcon,VSelect,VSpacer,VToolbar})
